(function () {
	"use strict";

	/*global angular*/
	var app = angular.module('cccu.photoUpload.index', ['ui.router']);

	app.config(function ($stateProvider) {
		$stateProvider.state('index', {
			url: '/',
			views: {
				"main": {
					controller: 'IndexController',
					templateUrl: 'index/index.html'
				}
			},
			data: {
				pageTitle: 'Upload your photo'
			}
		});
	});

	app.controller('IndexController', ['$scope', '$location', '$log', '$modal', 'deviceDetector', 'AppConfig', function ($scope, $location, $log, $modal, deviceDetector,AppConfig) {

	    // using this lib https://github.com/srfrnk/ng-device-detector/blob/master/ng-device-detector.js
	    // for a list of devices see the above link
        // check to see if we're using a native app and an unsupported device.
	    $scope.supported = AppConfig.isSupported(deviceDetector.device);
	    $scope.unsupportedDeviceMessage = AppConfig.unsupportedDeviceMessage;
	    $scope.isNative = AppConfig.isNative;
	    $scope.device = deviceDetector.device;

	    $scope.showBenefits = function () {
			$location.path('/benefits');
		};

		$scope.next = function () {
			$location.path('/instructions');
		};

		$scope.showBenefits = function () {
		    var modalInstance = $modal.open({
		        templateUrl: 'common/modalRender.html',
		        controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
		            $scope.modalHeader = 'Benefits of a Smartcard';
		            $scope.modalContent = 'index/benefits.html';
		            $scope.ok = function () {
		                $modalInstance.close();
		            };
		        }]
		    });
		}

    }]);
}());